import { useState } from "react";
import styles from "./avatar-generator.module.css";

function ExpandableSection({ label, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.optionGroup}>
      <div
        className={styles.label}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          userSelect: "none",
        }}
        onClick={() => setOpen(!open)}
      >
        <span>{label}</span>
        <span>{open ? "▲" : "▼"}</span>
      </div>

      <div
        style={{
          maxHeight: open ? "100%" : "0",
          overflow: "hidden",
          transition: "all 1s ease-in-out",
        }}
      >
        {open && <div className={styles.optionGrid}>{children}</div>}
      </div>
    </div>
  );
}

export default ExpandableSection;
